import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomFormModule } from '@shared/custom-form/custom-form.module';
import { SharedModule } from '@shared/shared.module';
import { IconsModule } from '@shared/icons/icons.module';
import { MeasurementRoutingModule } from './measurement-routing.module';
import { MeasurementListComponent } from './pages/measurement-list/measurement-list.component';
import { MeasurementViewComponent } from './pages/measurement-view/measurement-view.component';
import { MeasurementImportComponent } from './pages/measurement-import/measurement-import.component';
import { SelectMeasurementComponent } from './components/select-measurement/select-measurement.component';
import { ControlPanelComponent } from './components/control-panel/control-panel.component';
import { TrendGraphComponent } from './components/trend-graph/trend-graph.component';
import { ResponseGraphComponent } from './components/response-graph/response-graph.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { ReportActionsComponent } from './components/report-actions/report-actions.component';
import { MarkerAnnotationModalComponent } from './components/marker-annotation-modal/marker-annotation-modal.component';
import { MoveLocationModalComponent } from './components/move-location-modal/move-location-modal.component';
import { ScorecardModule } from 'app/features/shared/scorecard/scorecard.module';
import { FilterModule } from 'app/features/shared/component/filter/filter.module';

@NgModule({
    declarations: [
        MeasurementListComponent,
        MeasurementViewComponent,
        MeasurementImportComponent,
        SelectMeasurementComponent,
        ControlPanelComponent,
        TrendGraphComponent,
        ResponseGraphComponent,
        DataTableComponent,
        ReportActionsComponent,
        MarkerAnnotationModalComponent,
        MoveLocationModalComponent
    ],
    imports: [
        SharedModule,
        IconsModule,
        CustomFormModule,
        MeasurementRoutingModule,
        NgbDropdownModule,
        ScorecardModule,
        FilterModule
    ]
})
export class MeasurementModule {}
